import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
// //////////////////////////////////////////////////////////////
import store from '@/store'
import { FinanceRoutes } from '@/Apps/Finance/router/index'
import { HRRoutes } from '@/Apps/HR/router/index'
import { SecurityRoutes } from '@/Apps/Security/router/index'
import { CatalogsRoutes } from '@/Apps/Catalogs/router'
import { InventoryRoutes } from '@/Apps/Inventory/router'
import { DashBoardRoutes } from '@/Apps/DashBoard/router'
import { BranchesRoutes } from '@/Apps/Branches/router'
import { ReportsRoutes } from '@/Apps/Reports/router'

const DefaultTitle = 'Cookies Core'

const Generalroutes :Array<CookiesRouter> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HelloFromCookies.vue'),
    meta: {
      Access: 'Main_Navigation',
      LoginHeader: true
    }
  },
  {
    path: '/Settings',
    name: 'Settings',
    redirect: '/Settings/System',
    component: () => import('@/views/Settings.vue'),
    meta: {
      Access: 'Main_Settings_View'
    },
    children: [
      {
        path: 'System',
        component: () => import('@/components/Settings/SystemConfig.vue'),
        meta: {
          Access: 'Main_Settings_System'
        }
      },
      {
        path: 'Account',
        component: () => import('@/components/Settings/Account.vue'),
        meta: {
          Access: 'Main_Settings_Account'
        }
      },
      {
        path: 'CompanyInfo',
        component: () => import('@/components/Settings/CompanyInfo.vue'),
        meta: {
          Access: 'Main_Settings_Company'
        }
      },
      {
        path: 'Integration',
        component: () => import('@/components/Settings/Integration.vue'),
        meta: {
          Access: 'Main_Settings_Integration'
        }
      },
      {
        path: 'SuperAdmin',
        component: () => import('@/components/Settings/SuperAdmin.vue'),
        meta: {
          Access: 'SuperAdmin'
        }
      }
    ]
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/',
    meta: {
      Access: 'Main_Public'
    }
  }
]

var routes :Array<RouteRecordRaw> = []

// routes = routes.concat(OldRoutes)
routes = routes.concat(HRRoutes)
routes = routes.concat(SecurityRoutes)
routes = routes.concat(InventoryRoutes)
routes = routes.concat(CatalogsRoutes)
routes = routes.concat(DashBoardRoutes)
routes = routes.concat(BranchesRoutes)
routes = routes.concat(ReportsRoutes)
routes = routes.concat(FinanceRoutes)
routes = routes.concat(Generalroutes)

const router = createRouter({
  history: createWebHistory(),
  // mode: 'history',
  routes
})
var FirstTime = true
router.beforeEach((to) => {
  // alert(to.meta.Access)
  if (FirstTime) {
    to.query = {}
    FirstTime = false
    return to
  }
  const storeData = store as any
  // console.log('to.meta.Access')
  // console.log(to)
  // console.log(to.meta.Access)
  // console.log(storeData.state)
  // console.log(storeData.state.UserManagment.Status)
  // console.log(storeData.state.UserManagment.CurrentUser.RoleNames)
  // try {
  //   console.log(storeData.state.UserManagment.CurrentUser.RoleNames.indexOf(to.meta.Access))
  //   console.log(storeData.state.UserManagment.CurrentUser.RoleNames.indexOf(to.meta.Access) === -1)
  // } catch (error) {
  // }
  var RouteMetaAccess :string = to.meta.Access as string
  if (RouteMetaAccess.slice(-6) !== 'Public' as AccessFeature && storeData.state && storeData.state.UserManagment.Status && storeData.state.UserManagment.CurrentUser.RoleNames.indexOf('SuperAdmin') === -1 && storeData.state.UserManagment.CurrentUser.RoleNames.indexOf(to.meta.Access) === -1) {
    return false
  }
})

router.afterEach((to) => {
  document.title = to.name as string || DefaultTitle
})
export const GeneralRoutes = Generalroutes

export default router
